import React from 'react'

import { UserLoan } from '@matech/thebigpos-sdk'

import getBorrowerAndCoBorrowerUserFromLoanList from '../utils/getBorrowerAndCoBorrowerFromLoanList'
import { concatStrings } from '../../../../services/helpers'

type BorrowerNamesCellProps = Readonly<{
	userLoans: UserLoan[]
}>

function BorrowerNamesCell({ userLoans }: BorrowerNamesCellProps) {
	const { borrower, coBorrower } =
		getBorrowerAndCoBorrowerUserFromLoanList(userLoans)

	return (
		<div className="flex flex-col min-w-0 gap-1">
			<p className="truncate">
				{concatStrings(
					borrower?.firstName,
					borrower?.lastName
				).getValue()}
			</p>
			{coBorrower?.firstName && coBorrower.lastName && (
				<p className="truncate">
					{concatStrings(
						coBorrower?.firstName,
						coBorrower?.lastName
					).getValue()}
				</p>
			)}
		</div>
	)
}

export default BorrowerNamesCell
